import { updateDocuments } from '@lifetools/shared-database';

/**
 * Updates multiple remote documents in a single atomic batch commit. See `updateDocuments` in
 * `@lifetools/shared-database` for the semantics.
 *
 * @param {Array<{collection: string, id: string, values: object}>} updates
 *
 * @returns the values sent for each update (in the same order), with each result's `id` attached
 */
async function updateRemoteDocuments(updates) {
  const sentUpdates = await updateDocuments(updates);

  return sentUpdates.map((sent, index) => Object.assign({}, sent, { id: updates[index].id }));
}

export default updateRemoteDocuments;
